let baseURL = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = '/api'

} else if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://case-api.yestarshop.com'
}
export default baseURL